import { render } from "./AuthorizedContactForm.vue?vue&type=template&id=6d289b07&ts=true"
import script from "./AuthorizedContactForm.ts?vue&type=script&lang=ts&external"
export * from "./AuthorizedContactForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__